// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2pCiW","checkboxCol":"Table_checkboxCol__1-ml_","emailCol":"Table_emailCol__gr_X_","actionCol":"Table_actionCol__2ChqF"};